import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import update from 'react-addons-update';
import { push } from 'react-router-redux';
import { Switch, Radio } from 'rmwc';

import * as styles from '../../styles';
import { request } from '../../containers/actions';
import { host_nocdn, host_v2, imageUrl } from '../../utilities/requests';
import { setSelectedItems } from '../tree/actions';
import DatePicker from '../../date-picker/date_picker';
import QuestionsSelector from './question_selector';
import MarkersSelector from './markers_selector';
import QuestionDialog from '../questions/question_dialog';
import Layout from './layout';
import Tree from '../tree';
import * as actions from './actions';
import { resizer1100, resizer600, resizer800 } from '../../responsiver';


//@Radium
export default class Examination extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
        user: PropTypes.object,
        paginatorElementId: PropTypes.string,
    }

    state = {
        questionsLoaded: false,
        rendered_info: false,
        rendered_questions: false,
        rendered_layout: false,
        // azmon tafkiki
        seprate_examination: false
    };

    constructor(props, context) {
        super(props, context);
        this.closeQuestion = this.closeQuestion.bind(this);
        this.contentProcessor = this.contentProcessor.bind(this);
        this.checkConsolidatedAnalysis = this.checkConsolidatedAnalysis.bind(this);
    }

    async componentDidMount() {
        this.mounted = true;
        if (Number.parseInt(this.props.params.id) === this.state.id)
            return;
        await this.fetch.bind(this)(this.props.params.tab === 'questions' || this.props.params.tab === 'layout');
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.store.getIn(['regionsTree', 'selected']) !== this.props.store.getIn(['regionsTree', 'selected'])) {
            this.context.store.dispatch(setSelectedItems(
                [],
                'cities',
                this.props.store.getIn(['citiesTree', 'elementId']),
            ));
        }
        else if (nextProps.store.getIn(['citiesTree', 'selected']) !== this.props.store.getIn(['citiesTree', 'selected'])) {
            this.context.store.dispatch(setSelectedItems(
                [],
                'schools',
                this.props.store.getIn(['schoolsTree', 'elementId']),
            ));
        }
    }

    componentDidUpdate() {
        if (!this.state['rendered_' + this.props.params.tab]) {
            if ((this.props.params.tab === 'questions' || this.props.params.tab === 'layout') && !this.state.questionsLoaded)
                this.setState({
                    ['rendered_' + this.props.params.tab]: true,
                }, () => this.fetch.bind(this)(true));
            else
                this.setState({
                    ['rendered_' + this.props.params.tab]: true,
                });
        }
    }

    setExamination(examination, questionsLoaded) {
        this.setState({
            ...examination,
            questionsLoaded,
            materials_coefficients: examination.materials_coefficients || {},
            materials_types: examination.materials_types || {},
            rendered_info: false,
            rendered_questions: false,
            rendered_layout: false,
        });
        if (this.state.first_duration != 0 || this.state.second_duration != 0 || this.state.first_question_count != 0) {
            this.setState({
                seprate_examination: true
            })
        }
        this.context.store.dispatch([
            actions.setQuestions(
                examination.questions,
                this.props.store.getIn(['main', 'elementId']),
            ),
            actions.setLayoutOptions(
                { locked: examination.layout_locked, type: examination.type, settings: examination.layout },
                this.props.store.getIn(['layout', 'elementId']),
            ),
            setSelectedItems(
                examination.examination_type ? [examination.examination_type.id] : [],
                'examination-type',
                this.props.store.getIn(['typesTree', 'elementId']),
            ),
            setSelectedItems(
                _.map(examination.grades, grade => grade.id),
                'grade',
                this.props.store.getIn(['gradesTree', 'elementId']),
            ),
            setSelectedItems(
                [examination.paper_type],
                'paper-type',
                this.props.store.getIn(['paperTypesTree', 'elementId']),
            ),
            setSelectedItems(
                [examination.difficulty_level],
                'difficulty-level',
                this.props.store.getIn(['difficultyLevelsTree', 'elementId']),
            ),
        ]);
    }

    async _save(options) {
        try {
            // debugger;
            var questions = [
                ...this.props.store.getIn(['main', 'questions']).valueSeq().map(item => ({
                    question_id: item.get('question_id'),
                    ...this.props.store.getIn(['layout', 'questions', item.get('id')]).toJS(),
                    ..._.mapValues(_.mapKeys(
                        this.props.store.getIn(['layout', 'answers', item.get('id')]).toJS(),
                        (__, key) => key === 'scores' ? key : 'answer_' + key,
                    ), (value, key) => key === 'scores' ? _.values(value) : value),
                    id: item.get('id') > 0 ? item.get('id') : undefined,
                    fake: item.get('fake'),
                    coefficient: item.get('coefficient'),
                })).toArray()];
            for (var i = 0; i < questions.length; i++) {
                const element = document.createElement('div');
                element.innerHTML = questions[i].answer_content;
                const scoreItems = element.querySelectorAll('[data-score]');
                const scores = _.uniqBy(
                    _.map(scoreItems, item => ({ score: Number(item.dataset.score), id: item.dataset.scoreId })),
                    'id',
                );
                questions[i].scores = scores; 
            }
            const payload = {
                id: this.state.id,
                title: this.state.title,
                type: this.state.type,
                analyze_model: this.state.analyze_model,
                date: this.state.date,
                analyze_date: this.state.analyze_date,
                info: this.state.info,
                score: this.state.score,
                duration: this.state.duration,
                first_question_count: this.state.seprate_examination ? this.state.first_question_count : 0,
                first_duration: this.state.seprate_examination ? this.state.first_duration : 0,
                second_duration: this.state.seprate_examination ? this.state.second_duration : 0,
                beginning: this.state.beginning,
                end: this.state.end,
                note: this.state.note,
                online: this.state.online,
                restricted: this.state.restricted,
                unrestricted_beginning: this.state.unrestricted_beginning,
                unrestricted_end: this.state.unrestricted_end,
                unrestricted_duration: this.state.unrestricted_duration,
                for_sale: this.state.for_sale,
                correct_coefficient: this.state.correct_coefficient,
                incorrect_coefficient: this.state.incorrect_coefficient,
                empty_coefficient: this.state.empty_coefficient,
                materials_coefficients: this.state.materials_coefficients,
                materials_types: this.state.materials_types,
                published_key: this.state.published_key,
                advanced_report: this.state.advanced_report,
                twoModel_analyze: this.state.twoModel_analyze,
                entrance_examination: this.state.entrance_examination,
                public_exam: this.state.public_exam,
                private_booklet: this.state.private_booklet,
                layout_locked: this.state.layout_locked,
                complaint: this.state.complaint,
                special_general: this.state.special_general,
                participants_count: this.state.participants_count,
                fake_participants:this.state.fake_participants,
                examination_type: this.props.store.getIn(['typesTree', 'selected']).size
                    ? { id: this.props.store.getIn(['typesTree', 'selected']).keySeq().first() }
                    : null,
                step: this.state.step,
                grades: _.map(this.props.store.getIn(['gradesTree', 'selected']).toJS(), (__, key) => ({ id: key })),
                paper_type: this.props.store.getIn(['paperTypesTree', 'selected']).keySeq().first(),
                difficulty_level: this.props.store.getIn(['difficultyLevelsTree', 'selected']).keySeq().first(),
                show_booklet : this.state.show_booklet,
                ...this.state.questionsLoaded
                    ? {
                        layout: this.props.store.getIn(['layout', 'settings']),
                        questions
                    }
                    : {},
            };

            var date = Date.now();  
            const response = await this.context.store.dispatch(request({ 
                path: host_nocdn + `/api/examination/${this.state.id}/?${this.state.questionsLoaded ? 'detailed' : ''}`+'&uidate='+date,
                body: payload,
                method: 'PATCH',
            }));
            this.context.store.dispatch(actions.updateExamination(
                response,
                this.context.paginatorElementId,
                this.props.store.getIn(['main', 'elementId']),
            ));
            if (options.close)
                this.context.store.dispatch(push(this.props.urls.back.format(this.props.params)));
            this.setState({ saved: true });
            setTimeout(() => this.setState({ saved: undefined }), 5000);
        }
        catch (exception) {
            this.setState({ saved: false });
            setTimeout(() => this.setState({ saved: undefined }), 5000);
        }
    }

    async save(options = { close: false }) {
        _.debounce(this._save.bind(this))(options);
    }

    async fetch(detailed = false) {

        var date = Date.now();  
        let url = `/examination/${this.props.params.id}/?${detailed ? 'detailed' : ''}`+'&uidate='+date;
        const response = await this.context.store.dispatch(request(url));
        if (!this.mounted)
            return;
        this.setExamination(response, detailed);
    }

    closeQuestion() {
        const path = this.context.store.getState().getIn(['routing', 'locationBeforeTransitions', 'pathname']);
        this.context.store.dispatch(push(path.split('/').slice(0, -2).join('/') + '/'));
    }

    async checkConsolidatedAnalysis() {
        try {
            const token = this.context.store.getState().get('application').get('token');
            const response = await fetch(
                `${host_v2}/api/ConsolidateReportApi/CheckExamContentCanAnalyze/${this.state.id}`,
                {
                    method: 'GET',
                    headers: {
                        Accept: 'application/json',
                        Authorization: `${token.get('tokenType')} ${token.get('accessToken')}`,
                    },
                },
            );
            const result = await response.json();
            alert(result.errorId === 0 ? result.result : result.errorTitle);
        }
        catch (error) {
            console.log(error);
            alert('مشکلی در بررسی ساختار محتوایی آزمون پیش آمد.');
        }
    }

    contentProcessor(page, content) {
        try {
            return content.replace(
                /{{(.*?)(?::(.*?))?}}/g,
                (__, field, format) => ( () => {
                    if (field === 'page')
                        return page.persian();
                    else if (field === 'grade')
                        return this.state.grades?.length ? this.state.grades[0].title : '-';
                    else if (format && format.startsWith('img'))
                        return `<img style='width: 100%;' src='${imageUrl(window.images[field], {
                            ...format && format.startsWith('imgw') ? { width: Number(format.substr(4)) } : {},
                            ...format && format.startsWith('imgh') ? { height: Number(format.substr(4)) } : {},
                            type: 'contain',
                        })}'/>`;
                    else if (format && this.state[field] != undefined)
                        return this.state[field].toJalali().persian(format);
                    else
                        return this.state[field];
                })()
            ).replace(/<p><\/p>$/, '');
                }
        catch (exception) {
                return 'ERROR:' + exception.message;
            }
        }

    render() {
            if (this.props.module === 'markers')
                return <MarkersSelector {...this.props} />;
            return <div >
                {this.props.params.questionId && this.props.params.tab !== 'questions'
                    ? <QuestionDialog
                        elementId={this.props.store.getIn(['main', 'elementId']) + ':questions'}
                        store={this.props.store.get('questionDialog')}
                        id={this.props.params.questionId}
                        onClose={this.closeQuestion}
                    />
                    : null
                }
                {this.props.params.tab === 'layout' && [1, 2].includes(Number(this.state.examination_type?.id))
                    ? <div style={{ textAlign: 'center', marginBottom: '1em' }}>
                        <button
                            style={{ ...styles.button, minWidth: '24em' }}
                            onClick={this.checkConsolidatedAnalysis}>
                            بررسی ساختار محتوایی برای تحلیل تلفیقی
                        </button>
                    </div>
                    : null
                }
                <div style={{ position: 'relative' }}>
                    <div
                        style={{
                            position: 'absolute',
                            right: '50%',
                            transform: 'translateX(50%)',
                            top: '0',
                            fontWeight: '500',
                            fontSize: '1.4em',
                        }}>
                        {this.state.title
                            ? this.state.title + ' - ' + _.map(
                                this.state.grades,
                                grade => grade.title,
                            ).join(window.gettext(',') + ' ')
                            : null}
                    </div>
                    {this.context.user.hasPerm('examination.edit_profile')
                        ? <button
                            key='0'
                            style={this.props.params.tab === 'info'
                                ? styles.activeTabButton
                                : styles.tabButton
                            }
                            onClick={() => {
                                const path = this.context.store.getState().getIn(
                                    ['routing', 'locationBeforeTransitions', 'pathname'],
                                );
                                this.context.store.dispatch(push(path.split('/').slice(0, -2).join('/') + '/info/'));
                            }}>
                            {window.gettext('Info')}
                        </button>
                        : null
                    }
                    {this.context.user.hasPerm('examination.add_question')
                        ? <button
                            key='1'
                            style={this.props.params.tab === 'questions'
                                ? styles.activeTabButton
                                : styles.tabButton
                            }
                            onClick={() => {
                                const path = this.context.store.getState().getIn(
                                    ['routing', 'locationBeforeTransitions', 'pathname'],
                                );
                                this.context.store.dispatch(push(path.split('/').slice(0, -2).join('/') + '/questions/'));
                            }}>
                            {window.gettext('Question Selection')}
                        </button>
                        : null
                    }
                    {this.context.user.hasPerm('examination.layout')
                        ? <button
                            key='2'
                            style={this.props.params.tab === 'layout'
                                ? styles.activeTabButton
                                : styles.tabButton
                            }
                            onClick={() => {
                                const path = this.context.store.getState().getIn(
                                    ['routing', 'locationBeforeTransitions', 'pathname'],
                                );
                                this.context.store?.dispatch(push(path.split('/').slice(0, -2).join('/') + '/layout/'));
                            }}>
                            {window.gettext('Layout')}
                        </button>
                        : null
                    }
                    <button
                        key='close'
                        style={{ ...styles.button, float: 'left', marginRight: '.5em' }}
                        onClick={() => {
                            if (!window.confirm(window.gettext('Are you sure you' +
                                ' wanna cancel editing this' +
                                ' examination? Changes will be lost')))
                                return;
                            this.context.store.dispatch(push(this.props.urls.back.format(this.props.params)));
                        }}>
                        {window.gettext('Close')}
                    </button>
                    <button
                        key='save'
                        style={{
                            ...styles.button,
                            float: 'left',
                            marginRight: '.5em',
                            ...this.state.saved === true
                                ? {
                                    backgroundColor: "#1dd3b0",
                                    color : "white"
                                }
                                : this.state.saved === false
                                    ? {
                                        backgroundColor: styles.alertBackColor,
                                    }
                                    : {
                                        backgroundColor: 'white',
                                        transition: 'background-color 3500ms',
                                    },
                        }}
                        onClick={() => {
                            if (!window.confirm(window.gettext('Are you sure you wanna overwrite this examination') + (this.state?.beginning ? ('و همچنین زمان شروع آنلاین به ' + this.state?.beginning?.toJalali()?.persian('YYYY/MM/DD - HH:mm') + ' ثبت کنید ') : '') + '؟'))
                                return;
                        this.save.bind(this)({close: false});
                    }}>
                    {window.gettext('Apply')}
                </button>
                <button
                    key='save_and_close'
                    style={{ ...styles.defaultButton, float: 'left', marginRight: '.5em' }}
                    onClick={() => {
                        if (!window.confirm(window.gettext('Are you sure you wanna overwrite this examination') + (this.state?.beginning ? ('و همچنین زمان شروع آنلاین به ' + this.state?.beginning?.toJalali()?.persian('YYYY/MM/DD - HH:mm') + ' ثبت کنید ') : '') + '؟'))
                            return;
                        this.save.bind(this)({close: true});
                    }}>
                {window.gettext('Save')}
            </button>
            </div >
                <div style={{ clear: 'right', height: '1px' }}></div>
            {
                (this.props.params.tab === 'info' || this.state.rendered_info) && this.context.user.hasPerm('examination.edit_profile')
                ? <div
                    style={{
                        paddingTop: '.5em',
                        height: this.props.params.tab === 'info' ? undefined : '0',
                        overflow: this.props.params.tab === 'info' ? undefined : 'hidden',
                    }}>
                    <div
                        style={{
                            float: 'right',
                            clear: 'right',
                            width: 'calc(50% - 1em)',
                            marginLeft: '.5em',
                            marginRight: '.5em',
                        }}>
                        <input
                            key='title'
                            style={styles.field}
                            placeholder={window.gettext('Title')}
                            value={this.state.title || ''}
                            onChange={({ target: { value } }) => this.setState({ title: value.persian() })}
                        />
                    </div>
                    <div
                        style={{
                            float: 'right',
                            width: 'calc(17% - 1em)',
                            marginLeft: '.5em',
                            marginRight: '.5em',
                        }}>
                        <span style={{ marginLeft: '.5em' }}>
                            <Radio
                                checked={this.state.type === 1}
                                onChange={() => {
                                    actions.setLayoutOptions(
                                        { type: 1 },
                                        this.props.store.getIn(['layout', 'elementId']),
                                    );
                                    this.setState({ type: 1 });
                                }}>
                                {window.gettext('Multiple Choice')}
                            </Radio>
                        </span>
                        <span style={{ marginLeft: '.5em' }}>
                            <Radio
                                checked={this.state.type === 2}
                                onChange={() => {
                                    actions.setLayoutOptions(
                                        { type: 2 },
                                        this.props.store.getIn(['layout', 'elementId']),
                                    );
                                    this.setState({ type: 2 });
                                }}>
                                {window.gettext('Essay')}
                            </Radio>
                        </span>
                    </div>
                    <div
                        style={{
                            float: 'right',
                            width: 'calc(33% - 1em)',
                            marginLeft: '.5em',
                            marginRight: '.5em',
                        }}>
                        <span style={{ marginLeft: '.5em' }}>
                            <Switch
                                checked={!this.state.layout_locked}
                                onChange={() => {
                                    actions.setLayoutOptions(
                                        { locked: !this.state.layout_locked },
                                        this.props.store.getIn(['layout', 'elementId']),
                                    );
                                    this.setState({ layout_locked: !this.state.layout_locked });
                                }}>
                                {window.gettext('Ability to Layout')}
                            </Switch>
                        </span>
                        <span style={{ marginLeft: '.5em' }}>
                            <Switch
                                checked={this.state.published_key || false}
                                onChange={() => this.setState({ published_key: !this.state.published_key })}>
                                {window.gettext('Publish Key')}
                            </Switch>
                        </span>
                        <span>
                            <Switch
                                checked={this.state.analyze_model === 2}
                                onChange={({ target: { checked } }) => this.setState({ analyze_model: checked ? 2 : 1 })}>
                                {window.gettext('Analyze Based on Score')}
                            </Switch>
                        </span>
                        <span style={{ marginLeft: '.5em' }}>
                            <Switch
                                checked={this.state.advanced_report || false}
                                onChange={() => this.setState({ advanced_report: !this.state.advanced_report })}>
                                {window.gettext('Advanced Report')}
                            </Switch>
                        </span>
                        <span style={{ marginLeft: '.5em' }}>
                            <Switch
                                checked={this.state.twoModel_analyze || false}
                                onChange={() => this.setState({ twoModel_analyze: !this.state.twoModel_analyze })}>
                                {"تحلیل در دو جامعه"}
                            </Switch>
                        </span>
                        <span style={{ marginLeft: '.5em' }}>
                            <Switch
                                checked={this.state.entrance_examination || false}
                                onChange={() => this.setState({ entrance_examination: !this.state.entrance_examination })}>
                                {"آزمون ورودی"}
                            </Switch>
                        </span>
                        <span style={{ marginLeft: '.5em' }}>
                            <Switch
                                checked={this.state.private_booklet || false}
                                onChange={() => this.setState({ private_booklet: !this.state.private_booklet })}>
                                {"عدم نمایش دفترچه"}
                            </Switch>
                        </span>
                        <span style={{ marginLeft: '.5em' }}>
                            <Switch
                                checked={this.state.public_exam || false}
                                onChange={() => this.setState({ public_exam: !this.state.public_exam })}>
                                {"نمایش عمومی آزمون"}
                            </Switch>
                        </span>
                        <span style={{ marginLeft: '.5em' }}>
                            <Switch
                                checked={this.state.fake_participants || false}
                                onChange={() => this.setState({ fake_participants: !this.state.fake_participants })}>
                                    تعداد شرکت کنندگان دستی
                            </Switch>
                        </span>
                    </div>
                    <div style={{ ...treeStyle, width: 'calc(100%/8 - 1em)', clear: 'right' }}>
                        <Tree
                            store={this.props.store.get('typesTree')}
                            readonly
                            resource='examination-type'
                            multiSelection={false}
                            combobox
                            label={window.gettext('Type')}
                        />
                    </div>
                    <div
                        style={{
                            float: 'right',
                            width: 'calc(100%/8 - 1em)',
                            marginLeft: '.5em',
                            marginRight: '.5em',
                            display: 'grid',
                            gridTemplateColumns: 'min-content auto',
                            gridColumnGap: '.5em',
                        }}>
                        {window.gettext('Step')}:
                        <input
                            key='step'
                            style={{ ...styles.numberField, width: undefined }}
                            size='1'
                            value={(this.state.step || '').persian()}
                            onChange={({ target: { value } }) => this.setState({ step: value.english() })}
                        />
                    </div>
                    <div style={{ ...treeStyle, width: 'calc(100%/8 - 1em)' }}>
                        <Tree
                            store={this.props.store.get('gradesTree')}
                            readonly
                            resource='grade'
                            combobox
                            label={window.gettext('Grade')}
                        />
                    </div>
                    <div style={{ ...treeStyle, width: 'calc(100%/8 - 1em)' }}>
                        <Tree
                            store={this.props.store.get('paperTypesTree')}
                            readonly
                            resource='paper-type'
                            multiSelection={false}
                            combobox
                            label={window.gettext('Paper Type')}
                            staticItems={_.mapValues(
                                _.mapKeys(Array(2), (__, index) => Number(index) + 14),
                                (__, index) => ({ id: index, label: window.pgettext('examination', 'Paper-' + index) }),
                            )}
                        />
                    </div>
                    <div style={{ ...treeStyle, width: 'calc(100%/8 - 1em)' }}>
                        <Tree
                            store={this.props.store.get('difficultyLevelsTree')}
                            readonly
                            resource='difficulty-level'
                            multiSelection={false}
                            combobox
                            label={window.gettext('Difficulty Level')}
                            staticItems={_.mapValues(
                                _.mapKeys(Array(5), (__, index) => Number(index) + 1),
                                (__, index) => ({ id: index, label: window.pgettext('examination', 'Difficulty Level ' + index) }),
                            )}
                        />
                    </div>
                    <div
                        style={{
                            float: 'right',
                            width: 'calc(100%/6 - 1em)',
                            marginLeft: '.5em',
                            marginRight: '.5em',
                        }}>
                        {window.gettext('Date')}:
                        <DatePicker
                            containerStyle={{ width: '100%' }}
                            style={{
                                ...styles.numberInput,
                                width: '100%',
                            }}
                            timePickerComponent={null}
                            value={this.state.date}
                            onChange={value => this.setState({ date: value })}
                        />
                    </div>
                    <div
                        style={{
                            float: 'right',
                            width: 'calc(100%/6 - 1em)',
                            marginLeft: '.5em',
                            marginRight: '.5em',
                        }}>
                        {window.gettext('Analyze Date')}:
                        <DatePicker
                            containerStyle={{ width: '100%' }}
                            style={{
                                ...styles.numberInput,
                                width: '100%',
                            }}
                            timePickerComponent={null}
                            value={this.state.analyze_date}
                            onChange={value => this.setState({ analyze_date: value })}
                        />
                    </div>
                    <div
                        style={{
                            float: 'right',
                            width: 'calc(100%/6 - 1em)',
                            marginLeft: '.5em',
                            marginRight: '.5em',
                        }}>
                        <Switch
                            checked={this.state.complaint || false}
                            onChange={({ target: { checked } }) => this.setState({ complaint: checked })}>
                            {window.gettext('Ability to Complaint')}
                        </Switch>
                        <br />
                        <Switch
                            checked={this.state.special_general || false}
                            onChange={({ target: { checked } }) => this.setState({ special_general: checked })}>
                            {window.gettext('General/Special Materials')}
                        </Switch>
                    </div>
                    {this.state.type === 1
                        ? <div
                            style={{
                                float: 'right',
                                clear: 'right',
                                width: 'calc(50% - 1em)',
                                marginLeft: '.5em',
                                marginRight: '.5em',
                            }}>
                            {window.gettext('Options Coefficients')}:
                            <br />
                            <div
                                style={{
                                    float: 'right',
                                    width: 'calc(100% / 3 - 1em)',
                                    marginLeft: '.5em',
                                    marginRight: '.5em',
                                }}>
                                {window.gettext('Correct')}:&nbsp;
                                <input
                                    key='correct'
                                    style={{
                                        ...styles.numberField,
                                        width: '3em',
                                        direction: 'ltr',
                                        textAlign: 'right',
                                    }}
                                    value={(this.state.correct_coefficient || 0).persian()}
                                    onChange={({ target: { value } }) => this.setState({ correct_coefficient: value.english() })}
                                />
                            </div>
                            <div
                                style={{
                                    float: 'right',
                                    width: 'calc(100% / 3 - 1em)',
                                    marginLeft: '.5em',
                                    marginRight: '.5em',
                                }}>
                                {window.gettext('Incorrect')}:&nbsp;
                                <input
                                    key='incorrect'
                                    style={{
                                        ...styles.numberField,
                                        width: '3em',
                                        direction: 'ltr',
                                        textAlign: 'right',
                                    }}
                                    value={(this.state.incorrect_coefficient || 0).persian()}
                                    onChange={({ target: { value } }) => this.setState({ incorrect_coefficient: value.english() })}
                                />
                            </div>
                            <div
                                style={{
                                    float: 'right',
                                    width: 'calc(100% / 3 - 1em)',
                                    marginLeft: '.5em',
                                    marginRight: '.5em',
                                }}>
                                {window.gettext('Empty')}:&nbsp;
                                <input
                                    key='empty'
                                    style={{
                                        ...styles.numberField,
                                        width: '3em',
                                        direction: 'ltr',
                                        textAlign: 'right',
                                    }}
                                    value={(this.state.empty_coefficient || 0).persian()}
                                    onChange={({ target: { value } }) => this.setState({ empty_coefficient: value.english() })}
                                />
                            </div>
                        </div>
                        : <div
                            style={{
                                float: 'right',
                                clear: 'right',
                                width: 'calc(100%/6 - 1em)',
                                marginLeft: '.5em',
                                marginRight: '.5em',
                            }}>
                            {window.gettext('Score')}:
                            <input
                                key='score'
                                style={styles.numberField}
                                value={(this.state.score || '').persian()}
                                onChange={({ target: { value } }) => this.setState({ score: value.english() })}
                            />
                        </div>
                    }
                    {
                        !this.state.seprate_examination ?
                            <div>
                                <div
                                    style={{
                                        float: 'right',
                                        width: 'calc(100%/6 - 1em)',
                                        marginLeft: '.5em',
                                        marginRight: '.5em',
                                    }}>
                                    {window.gettext('Duration')}:
                                    <input
                                        key='duration'
                                        style={styles.numberField}
                                        value={(this.state.duration || '').persian()}
                                        onChange={({ target: { value } }) => this.setState({
                                            duration: value.english(),
                                            ...(this.state.unrestricted_duration === this.state.duration
                                                ? { unrestricted_duration: value.english() }
                                                : {}
                                            ),
                                        })}
                                    />
                                </div>
                            </div> : null
                    }
                    <div>
                        {
                            this.state.fake_participants ? 
                            <div
                            style={{
                                float: 'right',
                                width: 'calc(100%/6 - 1em)',
                                marginLeft: '.5em',
                                marginRight: '.5em',
                            }}>
                            {window.gettext('participants_count')}:
                            <input
                                key='participants_count'
                                style={styles.numberField}
                                value={(this.state.participants_count || 0).persian()}
                                onChange={({ target: { value } }) => this.setState({ participants_count: value.english() })} />
                        </div>
                            : null
                        }
                    </div>
                    <div
                        style={{
                            float: 'right',
                            clear: 'right',
                            width: 'calc(50% - 1em)',
                            marginLeft: '.5em',
                            marginRight: '.5em',
                        }}>
                        <textarea
                            key='note'
                            style={{
                                ...styles.field,
                                height: '5em',
                            }}
                            placeholder={window.gettext('Note')}
                            value={this.state.note || ''}
                            onChange={({ target: { value } }) => this.setState({ note: value.persian() })}>
                        </textarea>
                    </div>
                    <div
                        style={{
                            float: 'right',
                            width: 'calc(50% - 1em)',
                            marginLeft: '.5em',
                            marginRight: '.5em',
                        }}>
                        <textarea
                            key='information'
                            style={{
                                ...styles.field,
                                height: '5em',
                            }}
                            placeholder={window.gettext('Information')}
                            value={this.state.info || ''}
                            onChange={({ target: { value } }) => this.setState({ info: value.persian() })}>
                        </textarea>
                    </div>
                    {this.state.materials_coefficients && this.state.materials.length
                        ? <div
                            style={{
                                display: this.state.type === 1 ? undefined : 'none',
                                float: 'right',
                                width: 'calc(100% - 1em)',
                                marginLeft: '.5em',
                                marginRight: '.5em',
                            }}>
                            {window.gettext('Materials Coefficients')}:
                            <br />
                            {_.map(
                                this.state.materials,
                                material => <div
                                    key={'coefficient-' + material.id}
                                    style={{
                                        float: 'right',
                                        marginLeft: '.5em',
                                        marginRight: '.5em',
                                    }}>
                                    {material.title.persian()}:&nbsp;
                                    <input
                                        key={'coefficient-input-' + material.id}
                                        style={{
                                            ...styles.input,
                                            width: '3em',
                                            direction: 'ltr',
                                            textAlign: 'right',
                                        }}
                                        value={(this.state.materials_coefficients[material.id] || 1).persian()}
                                        onChange={({ target: { value } }) => this.setState(update(
                                            this.state,
                                            { materials_coefficients: { [material.id]: { $set: value.english() } } },
                                        ))}
                                    />
                                </div>,
                            )}
                        </div>
                        : null
                    }
                    {this.state.materials_types && this.state.materials.length
                        ? <div
                            style={{
                                display: this.state.type === 1 ? undefined : 'none',
                                float: 'right',
                                width: 'calc(100% - 1em)',
                                marginTop: '.5em',
                                marginLeft: '.5em',
                                marginRight: '.5em',
                            }}>
                            {window.gettext('Materials Types')}:
                            <br />
                            {_.map(
                                this.state.materials,
                                material => <div
                                    key={'type-' + material.id}
                                    style={{
                                        float: 'right',
                                        marginLeft: '.5em',
                                        marginRight: '.5em',
                                    }}>
                                    {material.title.persian()}:&nbsp;
                                    <input
                                        key={'type-input-' + material.id}
                                        style={{
                                            ...styles.input,
                                            width: '3em',
                                            direction: 'ltr',
                                            textAlign: 'right',
                                        }}
                                        value={(this.state.materials_types[material.id] || 1).persian()}
                                        onChange={({ target: { value } }) => this.setState(update(
                                            this.state,
                                            { materials_types: { [material.id]: { $set: value.english() } } },
                                        ))}
                                    />
                                </div>,
                            )}
                        </div>
                        : null
                    }
                    {this.state.type === 1
                        ? <div
                            style={{
                                float: 'right',
                                clear: 'right',
                                width: 'calc(100%/6 - 1em)',
                                marginLeft: '.5em',
                                marginRight: '.5em',
                                marginTop: '1em',
                                minHeight: '1.5em',
                            }}>
                            <span style={{ marginLeft: '.5em' }}>
                                <Switch
                                    checked={this.state.seprate_examination || false}
                                    onChange={() => this.setState({
                                        seprate_examination: !this.state.seprate_examination,
                                        duration: !this.state.seprate_examination === false ? 120 :
                                            parseInt(this.state.first_duration) + parseInt(this.state.second_duration),
                                        unrestricted_duration: !this.state.seprate_examination === false ? 120 :
                                            parseInt(this.state.first_duration) + parseInt(this.state.second_duration)
                                    })}>
                                    آزمون تفکیکی
                                </Switch>
                            </span>
                        </div>
                        : null
                    }
                    {this.state.type === 1 && this.state.seprate_examination
                        ? [

                            <div

                                style={{
                                    float: 'right',
                                    width: 'calc(100%/6 - 1em)',
                                    marginLeft: '.5em',
                                    marginRight: '.5em',
                                }}>
                                تعداد سوالات بخش اول:
                                <input
                                    key='first_question_count'
                                    containerStyle={{ width: '100%' }}
                                    style={styles.numberField}
                                    value={(this.state.first_question_count || '').persian()}
                                    onChange={({ target: { value } }) => this.setState({
                                        first_question_count: value.english(),
                                    })}
                                />
                            </div>,
                            <div

                                style={{
                                    float: 'right',
                                    width: 'calc(100%/6 - 1em)',
                                    marginLeft: '.5em',
                                    marginRight: '.5em',
                                }}>
                                زمان بخش اول آزمون:
                                <input
                                    key='first_duration'
                                    containerStyle={{ width: '100%' }}
                                    style={styles.numberField}
                                    value={(this.state.first_duration || '').persian()}
                                    onChange={({ target: { value } }) => this.setState({
                                        first_duration: value.english(),
                                        duration: parseInt(value.english()) + parseInt(this.state.second_duration),
                                        unrestricted_duration: parseInt(value.english()) + parseInt(this.state.second_duration)
                                    })}
                                />
                            </div>,
                            <div

                                style={{
                                    float: 'right',
                                    width: 'calc(100%/6 - 1em)',
                                    marginLeft: '.5em',
                                    marginRight: '.5em',
                                }}>
                                زمان بخش دوم آزمون:
                                <input
                                    key='second_duration'
                                    containerStyle={{ width: '100%' }}
                                    style={styles.numberField}
                                    value={(this.state.second_duration || '').persian()}
                                    onChange={({ target: { value } }) => this.setState({
                                        second_duration: value.english(),
                                        duration: parseInt(this.state.first_duration) + parseInt(value.english()),
                                        unrestricted_duration: parseInt(this.state.first_duration) + parseInt(value.english())
                                    })}
                                />
                            </div>,

                        ]
                        : null
                    }
                    {this.state.type === 1
                        ? <div
                            style={{
                                float: 'right',
                                clear: 'right',
                                width: 'calc(100%/6 - 1em)',
                                marginLeft: '.5em',
                                marginRight: '.5em',
                                marginTop: '1em',
                                minHeight: '1.5em',
                            }}>
                            <span style={{ marginLeft: '.5em' }}>
                                <Switch
                                    checked={this.state.online || this.state.online === null}
                                    onChange={() => {
                                        let newOnline;
                                        switch (this.state.online) {
                                            case null:
                                                newOnline = false;
                                                break;
                                            case false:
                                                newOnline = null;
                                                break;
                                            case true:
                                                newOnline = false;
                                                break;
                                        }

                                        this.setState({ online: newOnline })
                                    }}>
                                    {window.gettext('Online')}
                                </Switch>
                            </span>
                            <span style={{ marginLeft: '.5em' }}>
                                <Switch
                                    checked={this.state.online === false || this.state.online === null}
                                    onChange={() => {
                                        let newOnline;
                                        switch (this.state.online) {
                                            case null:
                                                newOnline = true;
                                                break;
                                            case false:
                                                newOnline = true;
                                                break;
                                            case true:
                                                newOnline = null;
                                                break;
                                        }

                                        this.setState({ online: newOnline })
                                    }}>
                                    {window.gettext('Paper Based')}
                                </Switch>
                            </span>
                        </div>
                        : null
                    }
                    {this.state.type === 1 && (this.state.online || this.state.online === null)
                        ? [
                            <div
                                key='beginning'
                                style={{
                                    float: 'right',
                                    width: 'calc(100%/6 - 1em)',
                                    marginLeft: '.5em',
                                    marginRight: '.5em',
                                }}>
                                {window.gettext('Online Beginning Date')}:
                                <DatePicker
                                    containerStyle={{ width: '100%' }}
                                    style={{
                                        ...styles.numberInput,
                                        width: '100%',
                                    }}
                                    value={this.state.beginning}
                                    to={this.state.end}
                                    onChange={value => this.setState({ beginning: value })}
                                />
                            </div>,
                            <div
                                key='end'
                                style={{
                                    float: 'right',
                                    width: 'calc(100%/6 - 1em)',
                                    marginLeft: '.5em',
                                    marginRight: '.5em',
                                }}>
                                {window.gettext('Online End Date')}:
                                <DatePicker
                                    containerStyle={{ width: '100%' }}
                                    style={{
                                        ...styles.numberInput,
                                        width: '100%',
                                    }}
                                    value={this.state.end}
                                    from={this.state.beginning}
                                    onChange={value => this.setState({ end: value })}
                                />
                            </div>,
                        ]
                        : null
                    }
                    {this.state.type === 1
                        ? <div
                            style={{
                                float: 'right',
                                clear: 'right',
                                width: 'calc(100%/6 - 1em)',
                                marginLeft: '.5em',
                                marginRight: '.5em',
                                marginTop: '1em',
                                minHeight: '1.5em',
                            }}>
                            <span style={{ marginLeft: '.5em' }}>
                                <Switch
                                    checked={this.state.restricted || false}
                                    onChange={() => this.setState({ restricted: !this.state.restricted })}>
                                    {window.gettext('Restricted')}
                                </Switch>
                            </span>
                        </div>
                        : null
                    }
                    {this.state.type === 1 && !this.state.restricted
                        ? [
                            <div
                                key='unrestricted-beginning'
                                style={{
                                    float: 'right',
                                    width: 'calc(100%/6 - 1em)',
                                    marginLeft: '.5em',
                                    marginRight: '.5em',
                                }}>
                                {window.gettext('Unrestricted Beginning Date')}:
                                <DatePicker
                                    containerStyle={{ width: '100%' }}
                                    style={{
                                        ...styles.numberInput,
                                        width: '100%',
                                    }}
                                    value={this.state.unrestricted_beginning}
                                    to={this.state.unrestricted_end}
                                    onChange={value => this.setState({ unrestricted_beginning: value })}
                                />
                            </div>,
                            <div
                                key='unrestricted-end'
                                style={{
                                    float: 'right',
                                    width: 'calc(100%/6 - 1em)',
                                    marginLeft: '.5em',
                                    marginRight: '.5em',
                                }}>
                                {window.gettext('Unrestricted End Date')}:
                                <DatePicker
                                    containerStyle={{ width: '100%' }}
                                    style={{
                                        ...styles.numberInput,
                                        width: '100%',
                                    }}
                                    value={this.state.unrestricted_end}
                                    from={this.state.unrestricted_beginning}
                                    onChange={value => this.setState({ unrestricted_end: value })}
                                />
                            </div>,
                            <div
                                key='unrestricted-duration-container'
                                style={{
                                    float: 'right',
                                    width: 'calc(100%/6 - 1em)',
                                    marginLeft: '.5em',
                                    marginRight: '.5em',
                                }}>
                                {window.gettext('Unrestricted Duration')}:
                                <input
                                    key='unrestricted-duration'
                                    style={styles.field}
                                    value={(this.state.unrestricted_duration || '').persian()}
                                    onChange={({ target: { value } }) => this.setState({ unrestricted_duration: value.english() })}
                                />
                            </div>,
                        ]
                        : null
                    }
                    <div
                        style={{
                            clear:'right',
                            float: 'right',
                            width: 'calc(100%/6 - 1em)',
                            marginLeft: '.5em',
                            marginRight: '.5em',
                        }}>
                        {window.gettext('Show Booklet Date')}:
                        <DatePicker
                            containerStyle={{ width: '100%' }}
                            style={{
                                ...styles.numberInput,
                                width: '100%',
                            }}
                            value={this.state.show_booklet}
                            onChange={value => this.setState({ show_booklet: value })}
                        />
                    </div>
                    <div
                        style={{
                            float: 'right',
                            clear: 'right',
                            width: 'calc(100%/6 - 1em)',
                            marginLeft: '.5em',
                            marginRight: '.5em',
                            marginTop: '1em',
                            minHeight: '1.5em',
                        }}>
                        <span style={{ marginLeft: '.5em' }}>
                            <Switch
                                checked={this.state.for_sale || false}
                                onChange={() => this.setState({ for_sale: !this.state.for_sale })}>
                                {window.gettext('Supply in Store')}
                            </Switch>
                        </span>
                    </div>
                    {this.context.user.hasPerm('examination.lock')
                        ? <div
                            style={{
                                float: 'left',
                                width: 'calc(100%/6 - 1em)',
                                marginLeft: '.5em',
                                marginRight: '.5em',
                                marginTop: '1em',
                                minHeight: '1.5em',
                            }}>
                            <Switch
                                checked={this.state.locked || false}
                                onChange={async ({ target: { checked } }) => {
                                    if (checked) {
                                        if (!window.confirm(window.gettext('Are you sure you wanna lock this examination?')))
                                            return;
                                    }
                                    else {
                                        if (!window.confirm(window.gettext('Are you sure you wanna unlock this examination?')))
                                            return;
                                    }
                                    const response = await this.context.store.dispatch(request({
                                        path: `/examination/${this.state.id}/lock/`,
                                        method: checked ? 'POST' : 'DELETE',
                                    }));
                                    if (response.done === 'locked')
                                        this.setState({ locked: true });
                                    if (response.done === 'unlocked')
                                        this.setState({ locked: false });
                                }}>
                                <i style={{ color: styles.alertColor }} className='fa-lock fa-lg' /> {window.gettext('Lock')}
                            </Switch>
                        </div>
                        : null
                    }
                </div>
                : null
            }
            {
                (this.props.params.tab === 'questions' || this.state.rendered_questions) && this.context.user.hasPerm('examination.add_question')
                ? <div
                    style={{
                        height: this.props.params.tab === 'questions' ? undefined : '0',
                        overflow: this.props.params.tab === 'questions' ? undefined : 'hidden',
                    }}>
                    <QuestionsSelector
                        active={this.props.params.tab === 'questions'}
                        {...this.props}
                    />
                </div>
                : null
            }
            {
                (this.props.params.tab === 'layout' || this.state.rendered_layout) && this.context.user.hasPerm('examination.layout')
                ? <div
                    style={{
                        height: this.props.params.tab === 'layout' ? undefined : '0',
                        overflow: this.props.params.tab === 'layout' ? undefined : 'hidden',
                    }}>
                    <Layout
                        store={this.props.store.get('layout')}
                        contentProcessor={this.contentProcessor}
                    />
                </div>
                : null
            }
        </div >;
        }
    }

    const treeStyle = {
        fontSize: '.8em',
        width: 'calc(100%/6 - 1em)',
        marginBottom: '1em',
        marginLeft: '.5em',
        marginRight: '.5em',
        float: 'right',
        maxHeight: '25em',
    };

    window.pgettext('examination', 'Paper-14');
    window.pgettext('examination', 'Paper-15');
